import { useCallback, useMemo, useState, type ReactNode } from 'react';
import {
  READ_STORAGE_KEY,
  ReadAnnouncementsContext,
  readReadAnnouncements,
} from '../lib/readAnnouncements';

export function ReadAnnouncementsProvider({ children }: { children: ReactNode }) {
  const [ids, setIds] = useState<Set<string>>(readReadAnnouncements);

  const markRead = useCallback((incoming: readonly string[]) => {
    setIds((previous) => {
      const unseen = incoming.filter((id) => !previous.has(id));
      if (unseen.length === 0) {
        // Nothing new to record, and returning the same set keeps the home badge from re-rendering.
        return previous;
      }

      const next = new Set([...previous, ...unseen]);
      window.localStorage.setItem(READ_STORAGE_KEY, JSON.stringify([...next]));
      return next;
    });
  }, []);

  const value = useMemo(() => ({ isRead: (id: string) => ids.has(id), markRead }), [ids, markRead]);

  return (
    <ReadAnnouncementsContext.Provider value={value}>{children}</ReadAnnouncementsContext.Provider>
  );
}
